import React, { useState } from 'react';

import { ConfirmationMessages } from '@netfront/ui-library';

import { getAriaDescribedBy, getHtmlElementOnChangeValueFromEvent, getInputFieldClassNames } from '../Snippets.helpers';

import { NumberSnippetProps } from './NumberSnippet.interfaces';

const NumberSnippet = ({
  describedById,
  id,
  isDirty,
  isDisabled,
  isRequired,
  placeholder,
  message,
  maxValue,
  minValue,
  onChange,
  value,
}: NumberSnippetProps) => {
  const { error: errorMessage, success: successMessage } = message ?? {};

  const [currentValue, setCurrentValue] = useState<number>(value);

  const ariaDescribedBy = getAriaDescribedBy(describedById, id, Boolean(errorMessage));
  const classNames = getInputFieldClassNames('number', isDirty, Boolean(errorMessage), isRequired);

  return (
    <React.Fragment>
      <input
        aria-describedby={ariaDescribedBy}
        aria-invalid={Boolean(errorMessage)}
        className={classNames}
        disabled={isDisabled}
        id={id}
        max={maxValue}
        min={minValue}
        placeholder={placeholder}
        required={isRequired}
        type="number"
        value={currentValue}
        onChange={(event) => {
          const updatedValue = Number(getHtmlElementOnChangeValueFromEvent(event));

          setCurrentValue(updatedValue);

          if (!onChange) {
            return;
          }

          onChange(updatedValue);
        }}
      />
      <ConfirmationMessages errorMessage={errorMessage} id={id} successMessage={successMessage} />
    </React.Fragment>
  );
};

export { NumberSnippet };
